import React from 'react';
import { createSvgIcon } from '@mui/material';

export const CardListPreview = createSvgIcon(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.00065 1.66669C4.08018 1.66669 3.33398 2.41288 3.33398 3.33335V5.00002C3.33398 5.9205 4.08018 6.66669 5.00065 6.66669H15.0007C15.9211 6.66669 16.6673 5.9205 16.6673 5.00002V3.33335C16.6673 2.41288 15.9211 1.66669 15.0007 1.66669H5.00065ZM15.0007 3.33335H5.00065V5.00002H15.0007V3.33335Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.00065 7.50002C4.08018 7.50002 3.33398 8.24621 3.33398 9.16669V10.8334C3.33398 11.7538 4.08018 12.5 5.00065 12.5H15.0007C15.9211 12.5 16.6673 11.7538 16.6673 10.8334V9.16669C16.6673 8.24621 15.9211 7.50002 15.0007 7.50002H5.00065ZM15.0007 9.16669H5.00065V10.8334H15.0007V9.16669Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33398 15C3.33398 14.0795 4.08018 13.3334 5.00065 13.3334H8.75065C8.75065 14.1667 8.75065 14.0795 8.75065 15C8.75065 15 8.75065 15 7.91732 18.3334H5.00065C4.08018 18.3334 3.33398 17.5872 3.33398 16.6667V15ZM5.00065 15H8.75065L7.91732 18.3334V16.6667H5.00065V15Z"
            fill="currentColor"
        />
        <path
            d="M6.28076 13.479C6.50083 11.4984 8.17495 10 10.1677 10H16.6673V18.3333L9.8678 17.8103C7.66244 17.6407 6.0365 15.6774 6.28076 13.479Z"
            fill="#E7E7E7"
        />
        <path
            d="M12.666 11.0909C14.7333 11.0909 16.5769 12.2527 17.4769 14.0909C16.5769 15.9291 14.7387 17.0909 12.666 17.0909C10.5933 17.0909 8.75511 15.9291 7.85511 14.0909C8.75511 12.2527 10.5987 11.0909 12.666 11.0909ZM12.666 10C9.93874 10 7.60965 11.6964 6.66602 14.0909C7.60965 16.4855 9.93874 18.1818 12.666 18.1818C15.3933 18.1818 17.7224 16.4855 18.666 14.0909C17.7224 11.6964 15.3933 10 12.666 10ZM12.666 12.7273C13.4187 12.7273 14.0297 13.3382 14.0297 14.0909C14.0297 14.8436 13.4187 15.4545 12.666 15.4545C11.9133 15.4545 11.3024 14.8436 11.3024 14.0909C11.3024 13.3382 11.9133 12.7273 12.666 12.7273ZM12.666 11.6364C11.3133 11.6364 10.2115 12.7382 10.2115 14.0909C10.2115 15.4436 11.3133 16.5455 12.666 16.5455C14.0187 16.5455 15.1206 15.4436 15.1206 14.0909C15.1206 12.7382 14.0187 11.6364 12.666 11.6364Z"
            fill="currentColor"
        />
    </svg>,
    'CardListPreview'
);
